module.exports = __webpack_public_path__ + "static/media/bd6.64c156f5.jpg";